import { AvaConfiguration } from './ava-configurations';
import versionInfo from '../../version-info.json';

export const environment: AvaConfiguration = {
    appVersion: `${versionInfo.version}.pre-prod`,
    buildNumber: versionInfo.buildNumber,
    production: false,
    defaultImageSrc: './assets/images/default.png',
    defaultCountry: 'IT',
    defaultLanguage: 'it',
    enableErrorLogging: false,
    enableErrorReporting: false,
    enableMultiCurrency: false,
    enableQueryLogs: true,
    enablePerformanceLogs: true,
    defaultCurrency: 'EUR',
    bufferTime: 10,
    maxBufferSize: 5,
    disableBuffer: false,
    subqueryLimit: 10,
    disableCache: false,
    encryptResponse: false,
    cartRetryLimit: 3,
    productIdentifier: 'Id',
    type: 'Salesforce',
    debounceTime: 1000,
    proxy: 'https://apttus-proxy.herokuapp.com',
    useIndexedDB: true,
    expandDepth: 8,
    skipPricing: true,
    skipRules: false,
    pricingMode: 'turbo',
    aboPricingMode: 'default',
    packageNamespace: 'Apttus_WebStore',
    storefront: 'EGL',
    organizationId: '00D3O0000008l85',
    endpoint: 'https://egl-apttus--bugfix.sandbox.my.site.com',
    auth: {
        clientId: '9bdbeb04-6d94-4236-a87c-a70c63b3b707',
        tenantId: 'c16e514b-893e-4a01-9a30-b8fef514a650',
        redirectUri: 'https://salesapp-bf.enigaseluce.com',
    },
};
